
{
  "familyId": "TAA-TEKSTSOORT",
  "questions": [
    {
      "id": "TAA-TEKSTSOORT-001",
      "familyId": "TAA-TEKSTSOORT",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_tekstsoorten",
      "questionType": "multiple_choice",
      "question": "Een tekst begint met: 'Er was eens een prinses die in een hoog kasteel woonde...' Welke tekstsoort is dit?",
      "context": null,
      "options": ["Sprookje (verhalend)", "Informatieve tekst", "Betoog", "Instructie"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tekstsoorten herkennen",
            "content": "Kenmerken van een sprookje: 'Er was eens...', fantasie-elementen (prinses, kasteel), verhalende structuur. Dit is een verhalende tekst (narratief).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_type_narrative",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: herken de kenmerken van de tekst. Stap 1: 'Er was eens' is een typische opening van een sprookje. Stap 2: Fantasie-elementen (prinses, kasteel). Stap 3: Dit is een verhalende tekst (sprookje).",
        "distractorExplanations": {
          "0": "Correct! 'Er was eens...' is de typische opening van een sprookje — een verhalende tekst.",
          "1": "Een informatieve tekst geeft feiten en uitleg, niet een fantasieverhaal met 'Er was eens...'.",
          "2": "Een betoog probeert je te overtuigen met argumenten. Dit is een verhaal, geen betoog.",
          "3": "Een instructie legt stap voor stap uit hoe je iets doet. Dit is een verhaal."
        }
      }
    },
    {
      "id": "TAA-TEKSTSOORT-002",
      "familyId": "TAA-TEKSTSOORT",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_tekstsoorten",
      "questionType": "multiple_choice",
      "question": "Een tekst legt uit hoe je een vogelhuisje maakt: 'Stap 1: Zaag de planken op maat. Stap 2: Lijm de zijkanten vast.' Welke tekstsoort is dit?",
      "context": null,
      "options": ["Instructie", "Sprookje", "Informatieve tekst", "Betoog"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Instructietekst",
            "content": "Kenmerken: stappen (Stap 1, Stap 2...), gebiedende wijs (zaag, lijm), doel = iets maken of doen. Dit is een instructietekst.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_type_instruction",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: kijk naar de structuur en het doel. Stap 1: De tekst heeft genummerde stappen. Stap 2: Gebiedende wijs (zaag, lijm). Stap 3: Doel = uitleggen hoe je iets maakt. Dit is een instructietekst.",
        "distractorExplanations": {
          "0": "Correct! Genummerde stappen + gebiedende wijs = instructietekst.",
          "1": "Een sprookje is een fantasieverhaal. Deze tekst legt uit hoe je iets maakt.",
          "2": "Een informatieve tekst geeft feiten, maar heeft geen stappen om iets te maken.",
          "3": "Een betoog probeert je te overtuigen. Deze tekst legt uit hoe je iets doet."
        }
      }
    },
    {
      "id": "TAA-TEKSTSOORT-003",
      "familyId": "TAA-TEKSTSOORT",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_tekstsoorten",
      "questionType": "multiple_choice",
      "question": "Een tekst in de krant beschrijft: 'De ijsbeer leeft op de Noordpool. Door klimaatverandering smelt het ijs steeds sneller.' Welke tekstsoort is dit?",
      "context": null,
      "options": ["Informatieve tekst", "Sprookje", "Instructie", "Gedicht"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Informatieve tekst",
            "content": "Kenmerken: feiten, uitleg, geen persoonlijke mening, zakelijke toon. De tekst geeft informatie over ijsberen en klimaatverandering.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_type_informative",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: kijk naar het doel en de toon. Stap 1: De tekst geeft feiten (ijsbeer, Noordpool, klimaatverandering). Stap 2: Zakelijke toon, geen fantasie of mening. Stap 3: Dit is een informatieve tekst.",
        "distractorExplanations": {
          "0": "Correct! Feiten + zakelijke toon = informatieve tekst.",
          "1": "Een sprookje is fantasie. Deze tekst gaat over echte feiten (ijsberen, klimaat).",
          "2": "Een instructie legt uit hoe je iets doet. Deze tekst geeft informatie.",
          "3": "Een gedicht heeft rijm, ritme en verzen. Deze tekst is proza (gewone zinnen)."
        }
      }
    },
    {
      "id": "TAA-TEKSTSOORT-004",
      "familyId": "TAA-TEKSTSOORT",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_tekstsoorten",
      "questionType": "matching",
      "question": "Koppel elke tekst aan de juiste tekstsoort.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["'Er was eens een draak...'", "'Stap 1: Meng de bloem...'", "'De aarde draait om de zon.'", "'Ik vind dat huisdieren...'"],
        "rightItems": ["Verhalend", "Instructie", "Informatief", "Betoog"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tekstsoorten koppelen",
            "content": "Verhalend: fantasie, 'Er was eens'. Instructie: stappen, gebiedende wijs. Informatief: feiten, uitleg. Betoog: mening, 'Ik vind dat...'.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_type_matching",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "'Er was eens een draak' = verhalend (sprookje). 'Stap 1: Meng de bloem' = instructie (recept). 'De aarde draait om de zon' = informatief (feit). 'Ik vind dat huisdieren...' = betoog (mening)."
      }
    },
    {
      "id": "TAA-TEKSTSOORT-005",
      "familyId": "TAA-TEKSTSOORT",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_tekstsoorten",
      "questionType": "multiple_choice",
      "question": "Een tekst begint met: 'Ik vind dat kinderen meer buiten moeten spelen. Ten eerste is het gezond. Ten tweede leer je samenwerken.' Welke tekstsoort is dit?",
      "context": null,
      "options": ["Betoog", "Informatieve tekst", "Instructie", "Verhalende tekst"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Betoog herkennen",
            "content": "Kenmerken: persoonlijke mening ('Ik vind dat...'), argumenten ('Ten eerste... Ten tweede...'), doel = overtuigen. Dit is een betoog.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_type_argument",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: kijk naar het doel en de structuur. Stap 1: 'Ik vind dat...' = persoonlijke mening. Stap 2: 'Ten eerste... Ten tweede...' = argumenten. Stap 3: Doel = overtuigen. Dit is een betoog.",
        "distractorExplanations": {
          "0": "Correct! Mening + argumenten + overtuigen = betoog.",
          "1": "Een informatieve tekst geeft feiten zonder mening. 'Ik vind dat...' is een mening.",
          "2": "Een instructie legt uit hoe je iets doet. Deze tekst probeert te overtuigen.",
          "3": "Een verhalende tekst vertelt een verhaal. Deze tekst geeft een mening met argumenten."
        }
      }
    }
  ]
}
